module.exports = __webpack_public_path__ + "static/media/membership2027-child-card.3580e159.png";